import { render, staticRenderFns } from "./cargo-holds.svg.vue?vue&type=template&id=4e42b30e&"
import script from "./cargo-holds.svg.vue?vue&type=script&lang=js&"
export * from "./cargo-holds.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports